import React, {Component, ReactNode} from 'react';
import Modal from 'components/Modal';
import {Button} from '@material-ui/core';
import './index.scss';

export interface ConfirmModalProps {
  open: boolean;
  onConfirm:()=>void;
  onCancel:()=>void;
  title: string;
  children?: ReactNode;
}

export default class ConfirmModal extends Component<ConfirmModalProps> {
  onCancelClick = () => {
   this.props.onCancel();
  };

  onConfirmClick = () => {
    this.props.onConfirm();
  };

  render() {
    return <Modal open={this.props.open} onClosing={this.props.onCancel} className='confirm-modal'>
      <h2>{ this.props.title }</h2>
      { this.props.children }
      <div className="actions">
        <Button onClick={this.onConfirmClick} className="confirm">Ok</Button>
        <Button onClick={this.onCancelClick} className="cancel">Cancel</Button>
      </div>
    </Modal>
  }
}